/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Authentication type for the integration
 * @export
 */
export const ControlAuthType = {
    Oauth2: 'oauth2',
    ApiToken: 'api_token',
    Basic: 'basic',
    Other: 'other'
} as const;
export type ControlAuthType = typeof ControlAuthType[keyof typeof ControlAuthType];


export function ControlAuthTypeFromJSON(json: any): ControlAuthType {
    return ControlAuthTypeFromJSONTyped(json, false);
}

export function ControlAuthTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAuthType {
    return json as ControlAuthType;
}

export function ControlAuthTypeToJSON(value?: ControlAuthType | null): any {
    return value as any;
}

